import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InvoiceService } from '../shared/services/invoice.service';
import { CustomMessageService } from '@admin/core/message.service';
import { CommonLookupItem } from '@admin/shared/models/common-lookup-item.model';
import { SendInvoiceRequestModel } from '@admin/billing/shared/send-invoice-request-model';
import { ApplicationMessage } from '@admin/core/models/application-message';
import { MessageType } from '@admin/core/models/enum/message-type';
import { ApplicationMessageSource } from '@admin/core/models/application-message-source';

@Component({
  selector: 'hr-send-invoice-dialog',
  templateUrl: './send-invoice-dialog.component.html',
  styleUrls: ['./send-invoice-dialog.component.less'],
  standalone: false,
})
export class SendInvoiceDialogComponent implements OnInit {
  public display: boolean;

  @Input()
  public invoices: number[]; // invoiceId

  @Output()
  public onUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();

  public customerAgents: any[]; // <id, name>
  public selectedCustomerAgents: any[];

  constructor(
    private invoiceService: InvoiceService,
    private messageService: CustomMessageService
  ) {
    this.display = false;
    this.customerAgents = [];
    this.selectedCustomerAgents = [];
  }

  send() {
    if (this.invoices == null || this.invoices.length == 0) {
      this.onCancel();
      return;
    }
    var confirmData = new SendInvoiceRequestModel();
    (confirmData.markedEntities = this.invoices),
      (confirmData.chosenCustomerAgents =
        this.selectedCustomerAgents.length > 0
          ? this.selectedCustomerAgents
          : null);

    this.invoiceService.sendInvoice(confirmData).subscribe((result) => {
      if (result.success) {
        if (result.sent) {
          this.display = false;
          this.onUpdate.emit(true);
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Success,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: result.displayMessage,
          });
        } else {
          this.customerAgents = this.convertToListBoxItem(result.agents);
          this.display = true;
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Info,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: result.displayMessage,
          });
        }
      } else {
        this.messageService.pushMessage(<ApplicationMessage>{
          type: MessageType.Error,
          sourceId: ApplicationMessageSource.global,
          summary: '',
          detail: result.displayMessage,
        });
        this.onCancel();
      }
    });
  }

  convertToListBoxItem(data: CommonLookupItem<number, string>[]) {
    var result = [];
    data.forEach((k) => {
      result.push({ label: k.text, value: k.value });
    });

    return result;
  }

  onCancel() {
    this.display = false;
    this.onUpdate.emit(false);
  }

  ngOnInit() {
    this.send();
  }
}
